
import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, HostListener, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CdkDragEnd } from '@angular/cdk/drag-drop';
import { SignPdfService } from '../sign-pdf.service';


@Component({
  selector: 'app-selection-area',
  templateUrl: './selection-area.component.html',
  styleUrls: ['./selection-area.component.css']
})
export class SelectionAreaComponent implements OnInit, OnChanges {

  px: number;
  py: number;
  draggingCorner: boolean;
  draggingWindow: boolean;
  resizer: any;

  @Output() widthEvent = new EventEmitter<any>();
  @Output() heightEvent = new EventEmitter<any>();
  @Output() offsetOfSelect = new EventEmitter<any>();

  @Input('width') public width: number = 0;
  @Input('height') public height: number = 0;
  @Input('left') public x: number = 0;
  @Input('top') public y: number = 0;
  // @Input('cdkDragFreeDragPosition') freeDragPosition: { x: number; y: number; }
  dragPosition = {x: 0, y: 0};
  // private _serviceid: string;
  // @Input() set serviceId(value: string) {
  // this._serviceid = value;
  //     this.changeHappened(this._serviceid);
  // }
  // get serviceId(): string {
  // return this._serviceid;
  // }


  @ViewChild("box") public box!: ElementRef;
  signImage!: string;
  sdkDragEndTag!: any;
  startClientX: any;
  startClientY: any;



  ngOnInit() {
    this.commonService.signImageData.subscribe(res => {
      this.signImage = res ? res : "";
    })
    this.dragPosition = {x: this.x, y: this.y};
  }
  ngOnChanges(changes: SimpleChanges) {
    this.width = changes.width.currentValue;
    this.height = changes.height.currentValue;
    this.x = changes.x.currentValue;
    this.y = changes.y.currentValue;
    this.sdkDragEndTag ? this.sdkDragEndTag.source._dragRef.reset():'';
    this.px = 0;
    this.py = 0;
    this.dragPosition = {x: this.x, y: this.y};
    this.sendSize(this.width, this.height)
  }

  dragEndOfDropedItems($event: any ) {

    let pageTag: any = document.getElementsByClassName('page')[0];
    let sectionTag: any = document.getElementById('section-1');
    let boxTag: any = document.getElementById('box');
    let offsetLeft = pageTag ? pageTag['offsetLeft'] : 0;
    let width = sectionTag.offsetWidth - boxTag.offsetWidth;
    let height = sectionTag.offsetHeight - boxTag.offsetHeight;

    let windowHeight = window.innerHeight - boxTag.offsetHeight;

    let dropedItemLeftOffset = (width + $event.distance.x) - offsetLeft; 
    let dropedItemTopOffset = $event.distance.y;

    this.x = (this.x + $event.distance.x) > width ? width : ((this.x + $event.distance.x) <= 0 ? 0 : (this.x + $event.distance.x));

    this.y = this.y + $event.distance.y > windowHeight ? windowHeight : ((this.y + $event.distance.y) <= 0 ? 0 : (this.y + $event.distance.y));
    this.dragPosition = {x: this.x, y: this.y};
    this.offsetOfSelect.emit({ left: this.x, top: this.y })
    this.sdkDragEndTag = $event

  }




  constructor(private commonService: SignPdfService) { 
    this.x = 300;
    this.y = 100;
    this.px = 0;
    this.py = 0;
    this.width = 600;
    this.height = 300;
    this.draggingCorner = false;
    this.draggingWindow = false;
    // this.minArea = 20000
  }

  // ngOnInit() {
  // }

  area() {
    return this.width * this.height;
  }


  topLeftResize(offsetX: number, offsetY: number) {
    this.x += offsetX;
    this.y += offsetY;
    this.width -= offsetX;
    this.height -= offsetY;
    this.sendSize(this.width, this.height)
    this.dragPosition = {x: this.x, y: this.y};
  }

  topRightResize(offsetX: number, offsetY: number) {
    this.y += offsetY;
    this.width += offsetX;
    this.height -= offsetY;
    this.sendSize(this.width, this.height)
    this.dragPosition = {x: this.x, y: this.y};
  }

  bottomLeftResize(offsetX: number, offsetY: number) {
    this.x += offsetX;
    this.width -= offsetX;
    this.height += offsetY;
    this.sendSize(this.width, this.height)
    this.dragPosition = {x: this.x, y: this.y};
  }

  bottomRightResize(offsetX: number, offsetY: number) {
    this.width += offsetX;
    this.height += offsetY;
    this.sendSize(this.width, this.height)
    this.dragPosition = {x: this.x, y: this.y};
  }

  onCornerClick(event: any, resizer?: Function) {
    this.draggingCorner = true;
    this.px = event.clientX ;
    this.py = event.clientY ;
    this.resizer = resizer;
    event.preventDefault();
    event.stopPropagation();
  }

  onCornerTouchStart(event: any, resizer?: Function) {
    let clientX = event.touches[0].clientX;
    let clientY = event.touches[0].clientY;
    this.draggingCorner = true;
    this.px  = clientX ;
    this.py = clientY ;
    this.resizer = resizer;
    event.preventDefault();
    event.stopPropagation();
  }
 

  sendSize(width: any, height: any) {
    this.widthEvent.emit(width)
    this.heightEvent.emit(height)
  }


  @HostListener('document:mousemove', ['$event'])
  onCornerMove(event: MouseEvent) {
    if (!this.draggingCorner) {
      return;
    }
    let offsetX = event.clientX - this.px;
    let offsetY = event.clientY - this.py;

    let lastX = this.x;
    let lastY = this.y;
    let pWidth = this.width;
    let pHeight = this.height;

    this.resizer(offsetX, offsetY);
    this.px = event.clientX;
    this.py = event.clientY;
  }

  @HostListener('document:mouseup', ['$event'])
  onCornerRelease(event: MouseEvent) {
    this.draggingWindow = false;
    this.draggingCorner = false;
  }

  @HostListener('document:touchmove', ['$event'])
  onCornerMoveTouch(event: any) {
    if (!this.draggingCorner) {
      return;
    }
    let clientX = event.touches[0].clientX;
    let clientY = event.touches[0].clientY;
    let offsetX = clientX - this.px;
    let offsetY = clientY - this.py;

    let lastX = this.x;
    let lastY = this.y;
    let pWidth = this.width;
    let pHeight = this.height;

    this.resizer(offsetX, offsetY);
    this.px = clientX;
    this.py = clientY;
  }

  @HostListener('document:touchend', ['$event'])
  onCornerReleaseTouch(event: MouseEvent) {
    this.draggingWindow = false;
    this.draggingCorner = false;
  }











}




